export class Activate {
  type: 'SUCCESS' = 'SUCCESS';

  static path = '/api/careRecipient/activate';
}
